export const CONTROL_UNIT_TECHNICAL_DATA_BASE_URL = 'http://www.siemens.com/tstcloud';
